import React from "react";
import { FileFormat } from "../DownloadData";

interface Props {
  fileFormat: FileFormat;
  setFileFormat: (v: FileFormat) => void;
}

const FILE_FORMATS: { value: FileFormat; label: string }[] = [
  { value: "excel", label: "Excel" },
  { value: "csv", label: "CSV" },
];

export function OutputConfigSection({ fileFormat, setFileFormat }: Props) {
  return (
    <div className="dd-section-card">
      <div className="dd-section-header">
        <h2 className="dd-section-title">3. Output Config (Export Personality)</h2>
      </div>

      <div className="dd-fields-row">
        <div className="dd-field-group">
          <span className="dd-field-label">File Format</span>
          <div className="dd-format-toggle-group" role="group" aria-label="File Format">
            {FILE_FORMATS.map((fmt) => (
              <button
                key={fmt.value}
                type="button"
                className={`dd-format-btn ${
                  fileFormat === fmt.value ? "dd-format-btn--active" : ""
                }`}
                onClick={() => setFileFormat(fmt.value)}
              >
                {fmt.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
